.donut {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.ring {
  position: relative;
}

.ring svg {
  display: block;
  overflow: visible;
}

.arc {
  outline: none;
  transition:
    opacity var(--dur-1) var(--ease-std),
    transform var(--dur-2) var(--ease-out);
}

.arc:focus-visible {
  stroke: var(--ink);
  stroke-width: 2px;
}

.openable {
  cursor: pointer;
}

.dim {
  opacity: 0.3;
}

.centre {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  text-align: center;
}

.centreValue {
  color: var(--ink);
  font-size: 20px;
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 1.1;
}

.centreLabel {
  color: var(--muted);
  font-size: var(--t-min);
}

/* The rows share four tracks (swatch, name, value, share): each row, and the toggle inside it, is a
   subgrid of them, so the values and the shares end on one line (alignment audit, 2026-11-03). */
.legend {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) max-content max-content;
  gap: 4px 8px;
  width: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
}

.item {
  display: grid;
  grid-template-columns: auto 1fr auto auto;
  grid-template-columns: subgrid;
  grid-column: 1 / -1;
  border-radius: var(--radius-ctl);
  color: var(--ink-2);
  font-size: var(--t-dense);
}

/* A legend row is a toggle (a button) or, for a slice with nothing to draw, plain words. */
.toggle {
  display: grid;
  grid-template-columns: auto 1fr auto auto;
  grid-template-columns: subgrid;
  grid-column: 1 / -1;
  align-items: center;
  column-gap: 8px;
  width: 100%;
  padding: 3px 6px;
  border: 0;
  border-radius: var(--radius-ctl);
  background: none;
  color: inherit;
  font: inherit;
  text-align: left;
}

button.toggle {
  cursor: pointer;
}

button.toggle:focus-visible {
  outline: 2px solid var(--focus);
  outline-offset: 1px;
}

.itemOn {
  background: var(--panel-2);
}

.itemOff .itemLabel,
.itemOff .itemValue,
.itemOff .itemShare {
  color: var(--muted);
  text-decoration: line-through;
}

.dotMark {
  width: 10px;
  height: 10px;
  border: 2px solid transparent;
  border-radius: 3px;
  box-sizing: border-box;
}

.itemLabel {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.itemValue {
  justify-self: end;
  color: var(--ink);
  font-weight: 650;
  text-align: right;
}

.itemShare {
  min-width: 44px;
  color: var(--muted);
  font-size: var(--t-min);
  text-align: right;
}

@media (prefers-reduced-motion: reduce) {
  .arc {
    transition: none;
  }
}
